export default __webpack_public_path__ + "static/media/transfusion-buret.63eef76f.jpg";